import { render, staticRenderFns } from "./artistList.vue?vue&type=template&id=0db02a9c&scoped=true&"
import script from "./artistList.vue?vue&type=script&lang=js&"
export * from "./artistList.vue?vue&type=script&lang=js&"
import style0 from "./artistList.vue?vue&type=style&index=0&id=0db02a9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db02a9c",
  null
  
)

export default component.exports